Vue.component('app-game-round-end', {
    mounted: function() {
        game.roundEndComponent = this;
    },
    data: function() {
        return {
            shouldShowModal: false,
            data: {},
        };
    },
    methods: {
        showModal: function(val) {
            this.shouldShowModal = val;
            game.roundEnded = val;
            if (game.roundEnded) {
                game.camera.zoom = 2;
            } else {
                game.resetZoom();
            }
        },
        showRoundEnd: function(data) {
            this.data = data;
            this.data.xpGain = 0;
            this.data.coinGain = 0;
            this.data.rankedUp = false;
            this.data.nextRank = 0;
            this.data.nextRankPercentage = 0;
            this.showModal(true);

            let xp = 0;
            let coins = 0;
            if (data.awards) {
                xp = data.awards.xp;
                coins = data.awards.coins;
            }

            setTimeout(() => {
                if (xp) {
                    let soundPlayTimer = 0;
                    let updateGain = (selector, count, counter) => {
                        setTimeout(() => {
                            this.data[selector] = count;
                            soundPlayTimer--;
                            if (soundPlayTimer <= 0) {
                                game.sounds['collect'].play();
                                soundPlayTimer = 2;
                            }
                            this.$forceUpdate();
                        }, counter * 75);
                    };

                    let counter = 0;
                    for (let i = 0; i <= xp + 50; i += 50) {
                        let count = i;
                        if (count > xp) {
                            count = xp;
                        }
                        updateGain('xpGain', count, counter);
                        counter++;
                    }

                    setTimeout(() => {
                        counter = 0;
                        for (let i = 0; i <= coins + 5; i += 5) {
                            let count = i;
                            if (count > coins) {
                                count = coins;
                            }
                            updateGain('coinGain', count, counter);
                            counter++;
                        }

                        setTimeout(() => {
                            if (data.isUser) {
                                let lastRank = Math.floor(RANK_CONSTANT * Math.sqrt(data.lastXp));
                                let rankRaw = RANK_CONSTANT * Math.sqrt(data.lastXp + xp);
                                let rank = Math.floor(rankRaw);
                                let nextRank = rankRaw - rank;

                                this.data.nextRank = rank + 1;
                                this.data.nextRankPercentage = Math.round(nextRank * 100);
                                this.$forceUpdate();

                                if (rank > lastRank) {
                                    setTimeout(() => {
                                        this.data.rankedUp = true;
                                        game.sounds['rank_up'].play();
                                        this.$forceUpdate();
                                    }, 500);
                                }
                            }
                        }, (counter * 75) + 100);

                    }, (counter * 75) + 100);
                }
            }, 600);
        },
        disconnect: function() {
            window.location.reload();
        }
    },
    template: `
    <div class="game-modal game-modal-trans" v-if="shouldShowModal">
        <div class="game-modal-roundend">
            <h1 style="margin-bottom:5px;">{{data.message}}</h1>
            <button v-if="!data.roundActuallyEnded" type="button" class="app-btn app-btn-danger" style="width:auto;" v-on:click="disconnect()">
                <i class="fa fa-close"></i> Disconnect
            </button>
        </div>
        <div class="text-center" style="margin-top:5px;">
            <h2 v-if="data.xpGain">+{{data.xpGain}} XP <img class="icon" src="assets/rank_icon.png"></h2>
            <h2 v-if="data.coinGain">+{{data.coinGain}} Coins <img class="icon" src="assets/money_icon.png"></h2>
        </div>
        <div class="game-modal-roundend-bottom">
            <h3 v-if="data.nextRank">Next Rank: {{data.nextRank}}</h3>
            <div v-if="data.nextRankPercentage" class="xp-bar" style="margin-bottom:5px;">
                <div class="xp-bar-inner">
                    {{data.nextRankPercentage}}%
                </div>
                <div class="xp-bar-inner-fill" v-bind:style="{width: data.nextRankPercentage + '%'}"></div>
            </div>
            <h3 v-if="data.rankedUp" style="color:yellow;"><i class="fa fa-arrow-circle-up"></i> Rank Up!</h3>
        </div>
    </div>
    `
})